import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisV,
  faFilePdf,
  faFileExcel,
} from "@fortawesome/free-solid-svg-icons";
import FilterContext from "../../../routes/FilterContext";
import Table from "react-bootstrap/Table";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import {
  BodyAsFormData,
  encodedUrlBuliding,
} from "../../../services/utilities/util";
import { connect } from "react-redux";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import jsPDF from "jspdf";
import md5 from "md5";
import { Link } from "react-router-dom";
import "jspdf-autotable";
import { downloadPdf } from "../../../services/utilities/util";
import { JsonToExcel } from "react-json-to-excel";
import { convertJsonForExcel } from "../../../services/utilities/util";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class OfficeStock extends React.Component {
  static contextType = FilterContext;

  constructor(props) {
    super(props);
  }

  state = {
    officeStock: [],
    filters: "",
    showLoader: false,
    showGraph: false,
    jsonForExcel: [],
  };

  componentDidMount() {
    this.setState({ showLoader: true, showGraph: false });
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    apiMiddleware
      .post("api/edge/office/get_office_stock", BodyAsFormData(filters))
      .then((res) => {
        let excelData = [];
        for (const [key, value] of Object.entries(res.data)) {
          excelData.push(value);
        }
        let splicedData = res.data;
        this.setState({ showLoader: false, showGraph: true });
        this.setState({
          officeStock: splicedData,
          jsonForExcel: convertJsonForExcel(excelData, {
            building_grade: { name: "Grade", type: "string" },
            no_of_buildings: { name: "Building", type: "int" },
            area: { name: "Area (msf)", type: "int" },
            passing_rent: {
              name: "Passing Rent (₹/sqft/month)",
              type: "int",
            },
            market_rent: { name: "Rent (₹/sqft/month)", type: "int" },
          }),
        });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters) {
      this.setState({ filters: this.props.filters });
      this.setState({ showLoader: true, showGraph: false });

      apiMiddleware
        .post(
          "api/edge/office/get_office_stock",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          let excelData = [];
          for (const [key, value] of Object.entries(res.data)) {
            excelData.push(value);
          }
          let splicedData = res.data;
          this.setState({ showLoader: false, showGraph: true });
          this.setState({
            officeStock: splicedData,
            jsonForExcel: convertJsonForExcel(excelData, {
              building_grade: { name: "Grade", type: "string" },
              no_of_buildings: { name: "Building", type: "int" },
              area: { name: "Area (msf)", type: "int" },
              passing_rent: {
                name: "Passing Rent (₹/sqft/month)",
                type: "int",
              },
              market_rent: { name: "Rent (₹/sqft/month)", type: "int" },
            }),
          });
        });
    }
  }

  render() {
    return (
      <div className="widget widgetTable" style={{ height: "auto!important" }}>
        {this.state.showLoader && (
          <div className="row">
            <div className="col-lg-12 text-center">
              <img src="/edge/images/edgeLoader.gif" />
            </div>
          </div>
        )}
        {this.state.showGraph && (
          <div className="row">
            <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
              <p>Office Stock</p>
            </div>
            <div className="col-lg-3 text-end">
              <p className="colorBlack downloads">
                <FontAwesomeIcon icon={faEllipsisV} />
                <ul className="downloadOptions">
                  <li
                    className="excelDownload"
                    onClick={(e) => {
                      // console.log(this.state.jsonForExcel);
                      let body = new FormData();
                      body.append("path", window.location.pathname);
                      body.append("action", "excel_export");
                      body.append("count", 1);
                      body.append(
                        "hash",
                        window.location.search.split("?").pop()
                      );
                      body.append("screen_sub_type", "Office Stock");
                      apiMiddleware
                        .post(process.env.REACT_APP_USER_ACTIVITY, body)
                        .then((res) => {});
                    }}
                  >
                    {/* <ReactHTMLTableToExcel
                      id="officeStockTableXlsButton"
                      className="download-table-xls-button"
                      table="officeStock"
                      filename="OfficeStock"
                      sheet="OfficeStock"
                      buttonText={"Download as Excel"}
                    /> */}
                    <JsonToExcel
                      title="Download as Excel"
                      data={this.state.jsonForExcel}
                      fileName="OfficeStock"
                      btnClassName="download-table-xls-button"
                    />
                  </li>
                  <li
                    className="pdfDownload"
                    onClick={(e) => {
                      downloadPdf("#officeStock", "OfficeStock");
                      let body = new FormData();
                      body.append("path", window.location.pathname);
                      body.append("action", "pdf_download");
                      body.append("count", 1);
                      body.append(
                        "hash",
                        window.location.search.split("?").pop()
                      );
                      body.append("screen_sub_type", "Office Stock");
                      apiMiddleware
                        .post(process.env.REACT_APP_USER_ACTIVITY, body)
                        .then((res) => {});
                    }}
                  >
                    <FontAwesomeIcon icon={faFilePdf} /> Download as PDF
                  </li>
                </ul>
              </p>
            </div>
            <div className="col-lg-12 mt-2 newFixedTable">
              <Table responsive hover id="officeStock">
                <thead>
                  <tr className="">
                    <th>
                      <span>Grade</span>
                    </th>
                    <th className="text-end">
                      <span>Building</span>
                    </th>
                    <th className="text-end">
                      <span>Area</span>
                    </th>
                    <th className="text-end">
                      <span>Passing Rent</span>
                    </th>
                    <th className="text-end">
                      <span>Market Rent</span>
                    </th>
                  </tr>
                  <tr className="thwithNoPadding">
                    <th></th>
                    <th></th>
                    <th className="text-end">
                      <b>(msf)</b>
                    </th>
                    <th className="text-end">
                      <b>(₹/sqft/month)</b>
                    </th>
                    <th className="text-end">
                      <b>(₹/sqft/month)</b>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.officeStock != undefined &&
                    Object.keys(this.state.officeStock).length > 0 &&
                    Object.keys(this.state.officeStock).map(function (
                      key,
                      index1
                    ) {
                      return (
                        <tr key={"officeStock" + index1}>
                          <td>
                            {this.state.officeStock[key].building_grade !==
                            undefined ? (
                              <Link
                                target="_blank"
                                to={encodedUrlBuliding(
                                  "building_grade",
                                  this.state.officeStock[key].building_grade
                                )}
                              >
                                {this.state.officeStock[key].building_grade}
                              </Link>
                            ) : (
                              this.state.officeStock[key].building_grade
                            )}
                          </td>
                          <td className="text-end">
                            {this.state.officeStock[key].no_of_buildings}
                          </td>
                          <td className="text-end">
                            {this.state.officeStock[key].area}
                          </td>
                          <td className="text-end">
                            {this.state.officeStock[key].passing_rent}
                          </td>
                          <td className="text-end">
                            {this.state.officeStock[key].market_rent}
                          </td>
                        </tr>
                      );
                    },
                    this)}
                </tbody>
              </Table>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps)(OfficeStock);
